import { apiFrontAccessLog } from '../../api/selfApi'
import { Middleware, Dispatch, AnyAction, MiddlewareAPI } from 'redux'
import { AppState } from '..'

export const accessLog: Middleware =
  <S extends AppState>(store: MiddlewareAPI<Dispatch, S>) =>
  (next: Dispatch<AnyAction>) =>
  (action: any) => {
    const result = next(action)
    if (action.type === '@@router/LOCATION_CHANGE') {
      const { pathname, search } = action.payload.location
      apiFrontAccessLog({ current: `${pathname}${search}` })
    }
    return result
  }
